module.exports = __webpack_public_path__ + "static/12th-518ccddeaedee39bdbb2671855f10024.png";